import { Component, OnInit } from '@angular/core';
import { AdComponent } from '../ad.component';

@Component({
  selector: 'ad-card',
  templateUrl: './ad-card.component.html',
  styleUrls: ['./ad-card.component.scss']
})
export class AdCardComponent extends AdComponent implements OnInit {

  ngOnInit(){
    this.srs.setFilterGroup('ad');
    this.setDefault();
//    super.ngOnInit();
    
  }
 
}
  